/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { useSelector, useStore } from "react-redux";

// reducers
import { selectCustomer, setActiveCustomer, clearActiveCustomer } from "hyc-store/reducers/customers";

// "controllers"
import { ProductController } from "controllers";

// components
import { CustomerStatusTag } from "shared/components/customers/misc/customer-status-tag";

const CustomSearchBar = ({ country, onChange, ...props }) => {

    const store = useStore();
    const [items, setItems] = useState([]);

    const activeCustomer = useSelector(selectCustomer);

    const handleChange = async (event) => {
        const { value } = event.target;

        if (!value) {
            setItems([]);
            return;
        }

        const newList = await ProductController.getUsersByQuery(value, 20, country);

        setItems(newList);
    }

    const clear = () => {
        store.dispatch(clearActiveCustomer());

        if (onChange) {
            onChange(null);
        }
    }

    const handleClick = (customer) => {
        setItems([]);

        if (onChange) {
            onChange(customer);
        }

        store.dispatch(setActiveCustomer(customer));
    }

    useEffect(() => {
        return () => {
            store.dispatch(clearActiveCustomer());
        }
    }, [store]);

    if (activeCustomer) {
        return (
            <>
                <small className="is-pulled-right">
                    <a onClick={clear}>Search again?</a>
                </small>

                <div className="panel-block p-4 is-shadowless">
                    <div className="columns is-mobile">
                        <div className="column">
                            <span className="tag is-white is-size-1">
                                {activeCustomer.boxes.length} <span className="ml-1 is-size-7">boxes</span>
                            </span>
                        </div>

                        <div className="column">
                            <p className="is-size-5">{activeCustomer.full_name}</p>
                            <p><small>{activeCustomer.email}</small></p>
                            <p><small>{activeCustomer.delivery_week}</small></p>
                        </div>

                        <div className="column">
                            <CustomerStatusTag customer={activeCustomer} />

                            <br />

                            <address>
                                <small>{activeCustomer.address}</small>
                                <p><small>{activeCustomer.zip_code}, {activeCustomer.city}</small></p>
                            </address>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <div className="field">
                <div className="control">
                    <label className="label is-size-6">Type to search for customer</label>
                    <input className="input"
                        type="text" placeholder="Search customer"
                        onChange={handleChange} />
                </div>
            </div>

            <nav className="panel is-over has-background-white">
                {items.map((customer) => (
                    <div key={customer.id} className="panel-block is-clickable p-4 is-shadowless" onClick={() => handleClick(customer)}>
                        <div className="columns is-mobile">
                            <div className="column">
                                <span className="tag is-light is-size-1">
                                    {customer.boxes.length} <span className="ml-1 is-size-7">boxes</span>
                                </span>
                            </div>

                            <div className="column">
                                <p className="is-size-5">{customer.full_name}</p>
                                <p><small>{customer.email}</small></p>
                                <p><small>{customer.delivery_week}</small></p>
                            </div>

                            <div className="column">
                                <CustomerStatusTag customer={customer} />

                                <br />

                                {customer.address &&
                                    (
                                        <address>
                                            <small>{customer.address}</small>
                                            <p><small>{customer.zip_code}, {customer.city}</small></p>
                                        </address>
                                    )
                                }
                            </div>
                        </div>

                    </div>
                ))}
            </nav>
        </>
    );
}

export { CustomSearchBar };
